<template>
	<div class="dashboard_home">
		<div class="hero">
			<v-card-title class="ml-10 main-title">
				<h1 class="subtitle is-3 main-title-text white--text">{{ $t('dashboard_dashboard') }}</h1>
      </v-card-title>
      <v-card-title class="ml-10 title">
          <b class="title-text"><h3 class="label white--text">{{ $t('welcome') }}, {{ user.name }}</h3></b>
      </v-card-title>
			<img src="@/assets/sky.jpg" width="100%" style="height: 300px">
		</div>
    <v-container>
      <div class="columns is-multiline">
        <div class="column is-6">
          <v-card class="elevation-6" style="width: 100%;" >
            <router-link to="/wishlist"><v-icon style="width: 100%; color: indigo;">mdi-tag-faces mdi-48px</v-icon>
            <v-card-title style="word-break: normal; font-size: 30px;">{{ $t('navigation_wishlist') }}</v-card-title></router-link>
          </v-card>
        </div>
        <div class="column is-6">
          <v-card class="elevation-6" style="width: 100%;" >
            <router-link to="/dashboard/notifications"><v-icon style="width: 100%; color: blue;">mdi-bell mdi-48px</v-icon>
            <v-card-title style="word-break: normal; font-size: 30px;">{{ $t('navigation_messages') }}</v-card-title></router-link>
          </v-card>
        </div>
        <div class="column is-6">
          <v-card class="elevation-6" style="width: 100%;" >
            <router-link to="/dashboard/qrcode"><v-icon style="width: 100%; color: purple;">mdi-go-kart-track mdi-48px</v-icon>
            <v-card-title style="word-break: normal; font-size: 30px;">{{ $t('navigation_qrcode') }}</v-card-title></router-link>
          </v-card>
        </div>
        <div class="column is-6">
          <v-card class="elevation-6" style="width: 100%;" >
            <router-link to="/dashboard/profile"><v-icon style="width: 100%; color: green;">mdi-account-card-details mdi-48px</v-icon>
            <v-card-title style="word-break: normal; font-size: 30px;">{{ $t('navigation_profile') }}</v-card-title></router-link>
          </v-card>
        </div>
      </div>
    </v-container>
	</div>
</template>

<script>
  import {fb,db} from '@/firebase'
  
	export default {
		name : "dashboard_home",
    data() {
      return {
        user: null,
      }
    },

    created () {
      db.collection('user').where('user_id','==',fb.auth().currentUser.uid).get()
      .then(snapshot=>{
        snapshot.forEach(doc => {
          this.user = doc.data(),
          this.user.id = doc.id
        })
      })
    }
	}
</script>

<style scoped>
  .main-title {
    position: absolute;
    top: 40px;
  }
  .title {
    position: absolute;
    top: 100px;
  }
  .main-title-text {
    font-size: 35px;
  }
  .title-text {
    font-size: 25px;
  }
  .left {
    float: right;
  }
</style>